import type { AuthService } from "@domain/port/AuthService";
import type { SessionStore } from "@domain/port/SessionStore";
import type { SignupRequest, TokenBundle } from "../model/Auth";

export interface Signup {
  execute(req: SignupRequest): Promise<void>;
}

export class SignupImpl implements Signup {
  constructor(
    private readonly service: AuthService,
    private readonly sessionStore: SessionStore,
  ) {}

  async execute(req: SignupRequest): Promise<void> {
    const res = await this.service.signup(req);
    const bundle: TokenBundle = {
      accessToken: res.accessToken,
      accessExpiresAt: res.accessExpiresAt,
    };
    this.sessionStore.set(bundle);
  }
}
